import React from 'react'
import { TransactionCoordinatorsContainerProps } from '../types'
import TransactionCoordinator from '../transactionCoordinator'

const TransactionCoordinatorsContainer: React.FC<
  TransactionCoordinatorsContainerProps
> = ({ closingOverviewStatus }) => {
  const { closing_status_count: transactionCoordinators = [] } =
    closingOverviewStatus

  return (
    <>
      {transactionCoordinators?.map((transactionCoordinator, index) => (
        <TransactionCoordinator
          key={`transaction_coordinator_${index}`}
          elmId={`transaction_coordinator_${index}`}
          transactionCoordinator={transactionCoordinator}
        />
      ))}
    </>
  )
}

export default TransactionCoordinatorsContainer
